import styled from 'styled-components';

export const SectionContentWrapper = styled.div`
  display: flex;
  align-items: center;
  height: calc(100vh - 90px);
  margin-left: ${(props) => (props.alt ? '0' : 'auto')};
  margin-right: ${(props) => (props.alt ? 'auto' : '0')};
  padding-right: ${(props) => (props.alt ? '0px' : '20px')};
  padding-left: ${(props) => (props.alt ? '20px' : '0px')};
  position: relative;
  top: 0;
  width: 50%;
  z-index: 1;

  @media (max-width: 970px) {
    height: auto;
    align-items: flex-start;
    left: 0;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 200px;
    position: relative;
    right: auto;
    width: 100vw;
  }
`;

export const SectionContentContainer = styled.div`
  line-height: 1.5;
  padding: 100px 200px 100px 100px;
  position: relative;

  @media (max-width: 970px) {
    padding: 30px 30px;
  }
`;

export const SectionContentBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff;
  width: 100%;
  height: 100%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 220ms ease-in-out;
  z-index: -1;
  transform: scale(${(props) => (props.hovered ? 0.98 : 1)});
`;

export const SectionTitle = styled.h4`
  &.section-title {
    color: #fec609;
    font-weight: 700;
    letter-spacing: 2px;
    margin: 0px;
    text-transform: uppercase;
    margin-bottom: 20px;
    font-size: 0.95rem;

    @media (max-width: 970px) {
      margin-bottom: 15px;
      font-size: 0.85rem;
    }
  }
`;

export const SectionHeader = styled.h2`
  &.section-header {
    color: #231f20;
    font-size: 3rem;
    font-weight: 900;
    line-height: 1;
    margin: 0px;
    margin-bottom: 20px;

    @media (max-width: 970px) {
      font-size: 2.5rem;
    }

    @media (max-width: 320px) {
      font-size: 2rem;
    }
  }
`;

export const SectionBody = styled.p`
  &.section-body {
    color: #414042;
    font-size: 1.1rem;
    font-weight: 100;
    margin: 0px;
    margin-bottom: 20px;

    @media (max-width: 970px) {
      font-size: 1rem;
    }
  }
`;
